import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CountriesInfo } from 'src/app/data/schema/countries-info';
import { RaffleStatus } from 'src/app/data/schema/raffle';
import { RaffleService } from 'src/app/data/service/raffle.service';
import { DataTableOptions, InputOptions } from 'src/app/core/component/data-table/data-table';
import { RaffleBasePage } from 'src/app/shared/raffle-base-page';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { TicketBook } from 'src/app/data/schema/ticket-book';

@Component({
  selector: 'app-raffle-summary',
  templateUrl: './raffle-summary.page.html',
  styleUrls: ['./raffle-summary.page.scss'],
})
export class RaffleSummaryPage extends RaffleBasePage implements OnInit {
  tiersDataTable: DataTableOptions;
  ticketsDataTable: DataTableOptions;
  prizesDataTable: DataTableOptions;

  raffleCountry = '';
  raffleProvince = '';
  ticketBooks: TicketBook[] = [];

  constructor(
    raffleService: RaffleService,
    authService: AuthenticationService,
    private modalCtrl: ModalController) {
    super(raffleService, authService);
  }

  ngOnInit() {
    this.loadData();
    this.initTicketTable();
    this.initPrizesTable();
  }

  async requestApproval() {
    const hasConfirmed = await this.confirmSomething(
      'Confirm Request for Approval',
      'Are you ready to send in your raffle for approval?'
    );
    if (hasConfirmed) {
      this.raffle.rejectReason = null; // ensure we don't set a reject reason otherwise the API might send it
      this.raffle.status = RaffleStatus.Pending;
      const didSave = await this.save();
      if (!didSave) {
        this.raffle.status = RaffleStatus.Draft;
      } else {
        ServiceHelper.displayAlert(
          'In Review',
          'Your raffle has been submitted for review. You will be notified via email of any updates.'
        );
        await this.dismiss();
      }
    }
  }

  async dismiss() {
    await this.modalCtrl.dismiss();
  }

  protected async postLoad() {
    // load full name of province/country
    this.raffleProvince = CountriesInfo.Provinces.find(obj => obj.code === this.raffle.province)?.name;
    this.raffleCountry = CountriesInfo.Countries.find(obj => obj.code === this.raffle.country)?.name;
    this.ticketBooks = await TicketBook.fetchForRaffle(this.raffle.raffleId);

    this.initTicketTable();
    this.initTiersTable();
    this.loaded = true;
    return true;
  }

  private async initTiersTable() {
    this.tiersDataTable = new DataTableOptions({
      type: 'pricingtier',
      showTotalRow: true,
      dataSet: this.raffle.pricingTiers,
      totalColumns: ['totalTickets', 'totalTiers'],
      headers: [
        { label: 'Tier', field: 'tierName', sortable: false },
        { label: '# of Tickets/Unit*', field: 'ticketQuantity', sortable: false },
        { label: 'Unit Price*', field: 'price', sortable: false, },
        { label: 'Units Available*', field: 'quantity', sortable: false },
        { label: 'Total # of Tickets', field: 'totalTickets', sortable: false },
        { label: 'Total Tier Value', field: 'totalTiers', sortable: false },
      ],
      columns: [
        { classProperty: 'tierName', type: InputOptions.TEXT },
        { classProperty: 'ticketQuantity', type: InputOptions.NUMBER },
        { classProperty: 'price', type: InputOptions.CURRENCY },
        { classProperty: 'quantity', type: InputOptions.NUMBER },
        { classProperty: 'totalTickets', type: InputOptions.NUMBER },
        { classProperty: 'totalTiers', type: InputOptions.CURRENCY },
      ]
    });
  }

  private initTicketTable() {
    this.ticketsDataTable = new DataTableOptions({
      type: 'ticketBook',
      dataSet: this.ticketBooks,
      showTotalRow: true,
      totalColumns: ['qty'],
      headers: [
        { label: 'Starting Ticket #*', field: 'startTicketNumber', sortable: false },
        { label: 'Quantity in Pack*', field: 'qty', sortable: false },
      ],
      columns: [
        { classProperty: 'startTicketNumber', type: InputOptions.NUMBER },
        { classProperty: 'qty', type: InputOptions.NUMBER }
      ]
    });
  }

  private initPrizesTable() {
    this.prizesDataTable = new DataTableOptions({
      type: 'prizes',
      dataSet: this.raffle.prizes,
      totalColumns: ['value'],
      headers: [
        { label: 'Type', field: 'prizeTypeStr' },
        { label: 'Name', field: 'name' },
        { label: 'Description', field: 'description' },
        { label: 'Value', field: 'dispValue' },
        { label: 'Draw Date', field: 'drawFmt' }
      ],
      columns: [
        { classProperty: 'prizeTypeStr', type: InputOptions.TEXT },
        { classProperty: 'name', type: InputOptions.TEXT },
        { classProperty: 'description', type: InputOptions.TEXT },
        { classProperty: 'dispValue', type: InputOptions.CURRENCY },
        { classProperty: 'drawFmt', type: InputOptions.TEXT },
      ]
    });
  }


}
